<template>
  <div class="student-base-information">
    <div class="left">
      <img class="avatar" src="../../../../assets/image/common/student-default-avatar.png"/>
      <div class="info">
        <div class="name">
          <span class="text">{{ data.lastName + ' ' + data.firstName }}</span>
          <span class="text zh">{{ data.nameZh }}</span>
        </div>
        <div class="other-info">
          <div class="info-accommodation">
            <span class="normal-text">{{ data.isNeedAccommodation === true ? $t('index.need') : $t('index.noNeed')}}{{$t('index.accommodation')}}</span>
          </div>
          <div class="info-airport-pickup">
            <span class="normal-text">{{ data.isNeedPickUp === true ? $t('index.need') : $t('index.noNeed')}}{{$t('index.airportPickup')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-button v-if="showEdit && $route.query.source !== 'bms'&&(!studentDto.status||studentDto.status===0||studentDto.status===2||studentDto.status===3)" size="small" class="add-student apply-button"  @click="handleSubmit">
        <img src="../../../../assets/image/common/system-noice.gif" alt="">
        <span>{{ $t('common.submit') }}</span>
      </el-button>
      <el-button v-if="showEdit && $route.query.source !== 'bms'&&(studentDto.status===1||studentDto.status===3)" size="small" class="add-student" type="primary" @click="addCourse">{{ $t('index.addApplyCourse') }}</el-button>
      <el-button v-if="showEdit && $route.query.source !== 'bms'" size="small" class="add-student" type="primary" @click="editStudentInfo">{{ $t('index.editStudentInfo') }}</el-button>
    </div>
  </div>
</template>

<script>
import { updateStudentStatusApi } from '@/api/student-management';
export default {
  name: 'studentBaseInformation',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    studentDto: {
      type: Object,
      default: () => ({})
    },
    showEdit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    editStudentInfo() {
      const agentId = this.$store.state.user.fkAgentId;
      const stuid = this.data.id;
      this.$router.push({ name: 'studentApplicationForm', params: { stuid }, query: { agid: agentId, activeNames: 'personalInfo' }});
    },
    // 加申
    async addCourse(){
      const stuid = this.data.id;
      const agentId = this.$store.state.user.fkAgentId;
      updateStudentStatusApi(3,stuid).then((res) => {
        this.$router.push({
          name: 'studentApplicationForm',
          params: { stuid },
          query: { agid: agentId }
        });
      })
    },
    // 提交申请
    handleSubmit(){
      const stuid = this.data.id;
      const agentId = this.$store.state.user.fkAgentId;
      this.$router.push({
        name: 'studentApplicationForm',
        params: { stuid },
        query: { agid: agentId,activeNames: 'applicationSch' }
      });
    }
  }
}
</script>

<style lang='scss'>
.student-base-information {
  width: 100%;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  // border-bottom: 1px solid #dfe6ec;
  padding: 16px;
  @keyframes changeColor {
    0% { background-color: #FF9600; }
    50% { background-color: #039855; }
    100% { background-color: #FF9600; }
  }
  .apply-button{
    color:#fff;
    animation: changeColor 1.5s infinite;
    position:relative;
    span{
      margin-left:8px
    }
    img{
      width:16px;
      margin-right:8px;
      position:absolute;
      left:8px;
      top:50%;
      transform: translateY(-50%);
    }
  }
  .left {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .avatar {
      display: block;
      width: 56px;
      height: 56px;
      margin-right: 18px;
    }
    .info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 56px;
      .name {
        font-weight: bold;
        font-size: 18px;
        .text {
          display: inline-block;
          &.zh {
            color: #999;
          }
        }
        .text + .text {
          margin-left: 0.5em;
        }
      }
      .other-info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .info-accommodation, .info-airport-pickup {
          display: inline-block;
          padding: 5px 10px;
          border-radius: 10px;
          font-size: 12px;
          line-height: 1;
        }
        .info-accommodation {
          background-color: #EAEAEA;
          color: #666666;
          margin-right: 10px;
        }
        .info-airport-pickup {
          background-color: #FFF0E3;
          color: #FF9600;
        }
      }
    }
  }
}
</style>